import firebase from 'firebase'
import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { AppState } from '../../store';
import { startListeningWords, stopListeningWords } from '../words'

export const USER_SIGNED_IN = "@auth/userSignedIn";
interface UserSignedIn {
    username: string,
    uid : string
}

export const USER_SIGNED_OUT = "@auth/userSignedOut";

// Action creators
const actionSignedIn = (args: UserSignedIn) => ({
  ...args,
  type: USER_SIGNED_IN
});

const actionSignedOut = () => ({ type: USER_SIGNED_OUT });

// Thunks
export const thunkLogInWithPopup = () => async (dispatch: any, getState: () => AppState) => {
    let state = getState();

    if (!state.auth.userIsSignedIn) { 
        let provider = new firebase.auth.GoogleAuthProvider();
        let userCredentials = await firebase.auth().signInWithPopup(provider);
    }
}

export const thunkLogOut = () => (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    let state = getState();

    if (state.auth.uid) { 
        firebase.auth().signOut();
        stopListeningWords(dispatch, state.auth.uid);
    }
}

// Other
export interface State {
    username?: string,
    uid?: string,
    userIsSignedIn: boolean
}

const initialState : State = {
    userIsSignedIn: false
}

export const reducer = (state: State = initialState, action: any) => {
    switch(action.type) {
        case USER_SIGNED_IN:
            return {
                ...state,
                username: action.username,
                userIsSignedIn: true,
                uid: action.uid
            }
        case USER_SIGNED_OUT:
            return {
                ...state,
                username: undefined,
                userIsSignedIn: false,
                uid: undefined
            }
        default:
            return state;
    }
};


export const configureStore = (dispatch: Dispatch<AnyAction>) => {
    firebase.auth().onAuthStateChanged(user => {
        if (user) {
            dispatch(actionSignedIn({
                uid: user.uid,
                username: user.displayName || "User"
            }));

            startListeningWords(dispatch, user.uid);
        } else {
            dispatch(actionSignedOut());
        }
    });
}